import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import style from './NewCustomPages.module.scss';
import { WallElectricalDetails, WallElectricalModification } from "./NewCustomPagesConstants";
import CustomFalseCeilingLegends from "../CustomFalseCeilingPage/CustomFalseCeilingLegends";
import CivilWorkOptions from "../CivilWorkServices/CivilWorkOptions";
import { saveUpdatedPageDetails, saveMetaDataUpdate } from "../../../actions/wizard";

const WallElectrical = (props: any) => {
  const dispatch = useDispatch();
  const { isDrawingsExporting } = props;
  const pageDetails = useSelector((state: any) => state.wizard.pageDetails);
  const requiredMetaDataUpdate = useSelector((state: any) => state.wizard.requiredMetaDataUpdate);

  const latestStateRef = useRef(requiredMetaDataUpdate);

  const [updatedValues, setUpdatedValues] = useState(pageDetails);

  useEffect(() => {
    setUpdatedValues(pageDetails)
  }, [pageDetails]);

  // Update the meta details while unmounting.
  useEffect(() => {
    return () => {
      updateDetailsInMeta(false);
    }
  }, [])

  // Updating Item details in meta data
  const updateItems = (details: any) => {
    const updatedObj: any = {
      ...updatedValues,
      metaData: {
        ...updatedValues?.metaData,
        [details.id]: details.value
      }
    };
    setUpdatedValues(updatedObj)
    dispatch(saveMetaDataUpdate(updatedObj))
  }

  // Save function to save details in API
  const updateDetailsInMeta = (required: boolean) => {
    if (latestStateRef.current) {
      dispatch(saveUpdatedPageDetails(latestStateRef.current, required));
      dispatch(saveMetaDataUpdate(false))
    }
  }

  // Created a debounce to update the exiting quote details 
  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      updateDetailsInMeta(true);
    }, 4000); // Adjust the delay (in milliseconds) as needed

    latestStateRef.current = requiredMetaDataUpdate;

    return () => {
      clearTimeout(debounceTimer);
    };
  }, [requiredMetaDataUpdate]);


  return (
    <section className={style.new_page_container}>
      <h2 className="section_heading">{updatedValues?.name}</h2>
      <div className={style.wall_electrical_container}>
        <div className={style.image_viewTab}>
          <div className={style.sow_info_tab}>
            {/* <h2 className="sub_tab_heading">Legend (Electrical)</h2>
            <CustomFalseCeilingLegends /> */}
            {
              WallElectricalDetails?.map((w: any, id: any) => (
                <div key={id} className={style.sow_options_tabs}>
                  <h2 className="sub_tab_heading">{w.label}</h2>
                  {
                    w?.options?.map((e, i) => (
                      <p><CivilWorkOptions details={e} optionsList={e?.options} isDrawingsExporting={isDrawingsExporting} updateDetails={(e) => updateItems(e)} itemDetails={updatedValues?.metaData} defaultText={'Select to add scope'} /></p>
                    ))
                  }
                </div>
              ))
            }
          </div>
          <div className={style.canvas_container}>
            <div className={style.legend_electrical}>
              <div>Legend(Electrical)</div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
            <section>
              {
                updatedValues?.elevationImage ? <img crossOrigin="anonymous" src={`${updatedValues?.elevationImage}?ver=${new Date().getTime()}`} alt="" className="image-view" /> :
                  <div>
                    <h4>Elevation with</h4>
                    <p>1) Woodwork Internal Elevation </p>
                    <p>2) Overall Wall dimensions; </p>
                    <p>3) Position of Switch Boxes and its module details; Dimension from floor (Y-Axis) & dimension from left side / right side wall (X-Axis) </p>
                    <p>4) Shifting / Creating / Addition / Closing details with legend </p>
                    <p>5) Dimensions showing Position of Cabinet lights; Dimensions showing length of cabinet profile lights </p>
                    <p>6) Looping details from switch box to cabinet lights / cabinet profile lights</p>
                  </div>
              }
            </section>
          </div>
        </div>
        <div className={style.electrical_footerView}>
          <div className={`${style.wall_electrical_modification} ${style.wall_electrical_annotation}`}>
            <h2 className="sub_tab_heading">Electrical Service</h2>
            <div>
              <div className={`${style.two_col_tab}`}>
                <h4>Annotation</h4>
                <h4>Service Name</h4>
              </div>
              {
                updatedValues?.serviceAnnotationMapping?.map((e, i) => (
                  <div className={`${style.two_col_tab}`}>
                    <p>{e?.annotation || '-'}</p>
                    <p>{e?.service || '-'}</p>
                  </div>
                ))
              }
            </div>
          </div>
          <div className={style.wall_electrical_modification}>
            <h2 className="sub_tab_heading">Electrical Modifications</h2>
            <div className={updatedValues?.electricalData?.length > 4 ? updatedValues?.electricalData?.length > 8 ? style.three_equal_tab : style.two_col_tab : ''}>
              <div className={`${style.four_col_tab}`}>
                <h4>No</h4>
                <h4>Description</h4>
                <h4>Point Type</h4>
                <h4>Additional Details</h4>
              </div>
              {
                updatedValues?.electricalData?.map((e, i) => (
                  <div className={`${style.four_col_tab}`}>
                    <p>{e?.caption}</p>
                    <p>{e?.description}</p>
                    <p>{e?.pointType}</p>
                    <p><input value={updatedValues?.metaData?.[`additionType_${i}`] || e?.moduleType || e?.description?.match(/\b\d+\s*Module\b/i)?.[0]} onChange={(v) => updateItems({ id: `additionType_${i}`, value: v.target.value })} /></p>
                  </div>
                ))
              }
            </div>
            <div className={updatedValues?.electricalData?.length > 4 ? updatedValues?.electricalData?.length > 8 ? style.three_equal_tab : style.two_col_tab : ''}>
              <div className={`${style.four_col_tab}`}>
                {
                  WallElectricalModification?.map((e, i) => {
                    if (updatedValues?.electricalData?.length && i > 3) {
                      return
                    }
                    return <p><CivilWorkOptions details={e} optionsList={e?.options} isDrawingsExporting={isDrawingsExporting} updateDetails={(e) => updateItems(e)} itemDetails={updatedValues?.metaData} type={!e?.id.includes('module') ? "input" : ''} /></p>
                  })
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default WallElectrical;